import Handlebars from 'handlebars';

// Make Handlebars available globally
window.Handlebars = window.Handlebars || Handlebars;

Handlebars.registerHelper('encode', function (str) {
    return encodeURIComponent(str);
});

Handlebars.registerHelper('inc', function(value, options) {
    return parseInt(value) + 1;
});

Handlebars.registerHelper('toLower', function(value, options) {
  return value.toLowerCase();
});

Handlebars.registerHelper('hasSelectedChild', function(filters) {
    return (typeof _.findWhere(filters, { selected: true }) !== 'undefined');
});

// Compare helper
// Usage: {{#compare value1 value2 operator="==="}}
//    {{/compare}}
//
Handlebars.registerHelper('compare', function(lvalue, rvalue, options) {

    if (arguments.length < 3) {
        throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
    }

    var operator = options.hash.operator || "===";

    var operators = {
        '==':     function(l,r) { return l == r; },
        '===':    function(l,r) { return l === r; },
        '!=':     function(l,r) { return l != r; },
        '!==':    function(l,r) { return l !== r; },
        '<':      function(l,r) { return l < r; },
        '>':      function(l,r) { return l > r; },
        '<=':     function(l,r) { return l <= r; },
        '>=':     function(l,r) { return l >= r; },
        'typeof': function(l,r) { return typeof l == r; }
    }

    if (!operators[operator]) {
        throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
    }

    var result = operators[operator](lvalue, rvalue);

    if (result) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }

});

export default Handlebars;
